import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import "./despre.css";

// //dsad
// const diana = "diana_iuga";

const MembruEchipa = ({ nume_poza, nume, email, telefon, rank }) => {
    const [hov, setHov] = useState(`/echipa/${nume_poza}1.jpg`);
    const style = hov ? { filter: "brightness(1.1)", width: "100%" } : { filter: "brightness(1)", width: "100%" };

    return ( <>
        <Grid item xs = { 12 } md = { 4 } lg = { 3 }>
        <div className = "membruEchipa"
			onMouseOver = {() => setHov(`/echipa/${nume_poza}2.jpg`)}
			onMouseLeave = {() => setHov(`/echipa/${nume_poza}1.jpg`)}>
			<img src = { hov } style = {{ width: "100%" }}/>
			<img src = { `/echipa/${nume_poza}2.jpg` } style = {{ width: 0, height: 0, opacity: 0 }}/>
			<Typography
				color = "textPrimary"
				variant = "h6"
				style = {{ fontSize: 18 }}
				component = "h6" > { nume }
			</Typography> 
			<Typography
					color = "textSecondary"
					variant = "body1"
					component = "strong"
					style = {{ fontSize: 14 }}
					gutterBottom > { rank }
			</Typography>
			<div className = "contact">
				<Typography
					color = "textSecondary"
					variant = "body2"
					component = "strong"
					gutterBottom > { telefon } { /*&middot;*/ } <br/> { email }
				</Typography>
			</div>
		</div> 
	</Grid>
</>);
};

const BCE = [{
        nume: "Roxana-Elena MATEI",
        functie: "Președinte OSUT",
        telefon: "0769 848 199",
        mail: "roxana@osut.ro",
        poza: "RoxanaM",
        },
    {
         nume: "Ecaterina CORBU",
         functie: "Vicepreședinte responsabil cu activitatea de reprezentare studențească OSUT",
         telefon: "0731 315 928",
         mail: "ecaterina.corbu@osut.ro",
         poza: "EcaterinaC",
    },
    
    {
        nume: "Vlad PETREA",
        functie: "Vicepreședinte responsabil cu organizarea internă și cu proiectele",
        telefon: "0753 046 861",
        mail: "vlad.petrea@osut.ro",
        poza: "PetreaV",
    },
	{
        nume: "Dariana-Florentina DUMITRESCU",
        functie: "Secretar General",
        telefon: "0768 717 088",
        mail: "dariana.dumitrescu@osut.ro",
        poza: "DarianaD",
    }, 
    
	{
        nume: "Radu Moldovan",
        functie: "Coordonator Social-Educațional-Cercetare (S.E.C)",
        telefon: "0728 878 536",
        mail: "radu.moldovan@osut.ro",
        poza: "RaduM",
    },
	{
        nume: "Bianca-Betina VARGA",
        functie: "Coordonator Imagine",
        telefon: "0728 233 522",
        mail: "bianca.varga@osut.ro",
        poza: "BiaV",
    },
    {
        nume: "Andreea-Ramona VISILEANU",
        functie: "Coordonator Relații Publice (PR)",
        telefon: "0729 029 267",
        mail: "andreea.visileanu@osut.ro",
        poza: "AndreeaV",
    },
    
    {
        nume: "Diana CODEA",
        functie: "Coordonator Fundraising (FR)",
        telefon: "0753 978 518",
        mail: "diana.codea@osut.ro",
        poza: "CodeaD",
    },
	{
        nume: "Vlad-Nicolae BUCUR",
        functie: "Coordonator Resurse Umane (HR)",
        telefon: "0744 789 779",
        mail: "vlad.bucur@osut.ro",
        poza: "VladB",
    }, 
	{
        nume: "Cătălin-Mihai GUGA",
        functie: "Coordonator IT&Logistică ",
        telefon: "0771 500 439",
        mail: "catalin.guga@osut.ro",
        poza: "GugaC",
    },

	{
        nume: "Denisa-Mihaela ȘUVEI",
        functie: "Cenzor",
        telefon: "0757 604 914",
        mail: "denisa.suvei@osut.ro",
        poza: "DenisaS",
    },
	{
        nume: "Ioan CHINDRIȘ",
        functie: "Cenzor",
        telefon: "0785 910 292",
        mail: "ioan.chindris@osut.ro",
        poza: "ChindrisI",
    },

    
    
];

const Echipa = () => {return (
	<>
        <Grid
			container direction = "row"
			justify = "flex-start"
			spacing = { 4 }
			alignItems = "stretch">
        	<Grid item xs = { 12 }md = { 12 }style = {{ position: "relative" }}>
				<div id = "descEchipa">
					<Typography
						color = "textPrimary"
						variant = "h3"
						component = "h3"
						gutterBottom >
        				Echipa
					</Typography> 
					<Typography
						color = "textSecondary"
						variant = "body1"
						component = "p"
						style = {{ maxWidth: "70ch", marginBottom: 40 }}>
        				Aceștia suntem noi, echipa Biroului de Conducere Extins din mandatul actual. Ne aflăm aici doar pentru că pe parcursul istoriei organizației, starea de spirit s-a transmis din generație în generație, fiecare având un lider curajos.
					</Typography>
				</div>
			</Grid>
			<Grid item xs = { 12 }md = { 12 }>
        		<Grid
					container spacing = { 4 }
					direction = "row"
					justify = "flex-start" >
                    {BCE.map((item) => (
					<>
						<MembruEchipa
							key = { item.mail }
							nume_poza = { item.poza }
							nume = { item.nume }
							rank = { item.functie }
							telefon = { item.telefon }
							email = { item.mail }/>
					</>))}
				</Grid>
			</Grid> 
		</Grid> 
	</>
    );
};
export default Echipa;